let appsSidebarWidth = '60px';
const colors = require('tailwindcss/colors');

module.exports = {
    content: [
        './resources/views/**/*.blade.php',
        './resources/js/**/*.{js,jsx,ts,tsx,vue}',
        './node_modules/@deegital/trustup-spa-js-assets/*.{js,vue}',
        './node_modules/@deegital/trustup-spa-js-assets/{apps,api,classes,components,css,i18n,public,routing,store,types}/**/*.{js,vue}',
    ],
    theme: {
        container: {
            center: true,
        },
        extend: {
            colors: {
                ...{
                    'slate': colors.slate,
                    'orange': colors.orange,
                },
                ...{
                    gray: {
                        '50': '#fafafb',
                        '100': '#f5f5f5',
                        '200': '#eeeeee',
                        '300': '#e0e0e0',
                        '400': '#bdbdbd',
                        '500': '#9e9e9e',
                        '600': '#757575',
                        '700': '#616161',
                        '800': '#424242',
                        '900': '#212121',
                    },
                    'auth-infobox': {
                        'bg': '#f5a50d',
                        'text': '#FFFFFF',
                    },
                    'trustup': '#f8be14',
                    'sidebar': '#fff',
                    'body': '#FFF',
                    'primary': '#002ED8',
                    'primary-dark': '#0328ad',
                    'sidebar-link': '#172851',
                    'sidebar-link-active': '#333',
                    'sidebar-link-hover': '#333',
                    'sidebar-link-icon': '#334155',
                    'sidebar-link-icon-active': '#1e293b',
                    'sidebar-link-icon-hover': '#1e293b',
                    'responsive-sidebar-link': '#999',
                    'responsive-sidebar-link-hover': '#666',
                    'sidebar-dark': '#ECEEF2',
                    'apps-sidebar': '#172851',
                    'apps-sidebar-dark': '#0b1835',
                    'apps-sidebar-active': '#1B429D',
                    'modal': 'rgba(10, 14, 46, 0.8)',
                    'account-status-live': '#59B756',
                    'account-status-test': '#D07231',
                    'cb-status-active': '#70c718',
                    'cb-status-in_trial': '#c7a118',
                    'cb-status-paused': '#b7b7b7',
                    'cb-status-cancelled': '#ea4242',
                    'cb-status-non_renewing': '#ea7042'
                }
            },
            boxShadow: {
                'input-focus': 'inset 0 0 0 1px #0072ff',
                'dropdown': '0 4px 6px 0 rgba(0, 0, 0, 0.1)',
                'top-bar': '0 1px 3px 0 rgba(29, 41, 84, 0.16)',
                'panel': '0 4px 15px 0 rgba(29, 41, 84, 0.08)',
                'button': 'inset 0 -1px 0 #19427d, 0 1px 2px rgba(0, 0, 0, 0.2)',
                'button-light': '0 1px 1px rgba(0, 0, 0, 0.2)'
            },
            top: {
                'top-bar': '60px',
            },
            inset: {
                'top-bar': '60px',
                'apps-sidebar': appsSidebarWidth,
            },
            height: {
                'top-bar': '60px',
            },
            padding: {
                '1/2': '0.125rem',
                'top-bar': '60px'
            },
            margin: {
                '05': '0.125rem',
                '-1/2': '-0.125rem',
            },
            width: {
                'login': '480px',
                'apps-sidebar': appsSidebarWidth,
                'sidebar-tablet': '60px',
                'sidebar': '220px',
                'settings-sidebar': '270px',
                'full': '100%',
                'screen': '100vw',
                'table-menu': '500px',
                'event-timeline-bar': '3px'
            },
            maxHeight: {
                '12': '3rem',
                '250': '250px',
            },
            maxWidth: {
                container: '1280px',
                'app_submenu': '300px',
                'input': '500px',
                'input-date': '180px',
                '1000': '1000px'
            },
            fontSize: {
                'xxs': '0.5rem'
            },
            borderWidth: {
                '3': '3px'
            },
            opacity: {
                '10': '0.1',
                '90': '0.9'
            },
            zIndex: {
                '99': '99',
                '100': '100'
            }
        }
    },
    variants: {
        backgroundColor: ['responsive', 'hover', 'focus', 'group-hover', 'important'],
        display: ['responsive', 'hover', 'focus', 'group-hover'],
        margin: ['responsive', 'hover', 'focus', 'group-hover'],
        padding: ['responsive', 'hover', 'focus', 'group-hover'],
        textColor: ['responsive', 'hover', 'focus', 'group-hover', 'important'],
        maxHeight: ['responsive', 'hover', 'focus', 'group-hover'],
        maxWidth: ['responsive', 'hover', 'focus', 'group-hover'],
        width: ['responsive', 'hover', 'focus', 'group-hover'],
    },
    plugins: [
        require('tailwindcss-multi-column')(),
        require('tailwindcss-important')()
    ]
};
